export default "__VITE_ASSET__CmvnQ_vh__"